import Illustrations from './Illustrations'
export default Illustrations
